<div class="box-shadow module">

  <div class="row">
    <!-- Business Unit Selector -->
    <div class="col-sm-3">
      <label class="fr__form-label">{{'FR.Filters.BusinessUnit' | translate}}</label>
      <p-dropdown id="selectBusinessUnit" name="selectBusinessUnit" [options]="businessUnits"
        [ngModel]="selectedBusinessUnit" [styleClass]="'fr__form-control'" (ngModelChange)="changeBusinessUnit($event)"
        optionLabel="Name" appendTo="body" placeholder="{{ 'Select Option' | translate }}"
        (onClick)="loadBusinessUnits()">
      </p-dropdown>
    </div>

    <!-- Asset Selector -->
    <div class="col-sm-3">
      <label class="fr__form-label"
        *ngIf="selectedBusinessUnit?.HierarchyLabel1">{{selectedBusinessUnit?.HierarchyLabel1}}</label>
      <label class="fr__form-label" *ngIf="!selectedBusinessUnit?.HierarchyLabel1">{{'Assets'|translate}}</label>
      <p-dropdown id="assetName" [options]="listAssets" [ngModel]="selectedAsset" optionLabel="Name"
        (ngModelChange)="changeAsset($event)" [disabled]="selectedBusinessUnit === null && listAssets.length === 0"
        appendTo="body" (onClick)="loadAssets(selectedBusinessUnit.Id)" [styleClass]="'fr__form-control'"
        placeholder="{{ 'Select Option' | translate }}">
      </p-dropdown>
    </div>

    <!-- Task Plan Selector -->
    <div class="col-sm-3">
      <label class="fr__form-label">
        {{'FR.Filters.ReviewType' | translate}}
      </label>
      <p-dropdown id="taskPlan" [options]="listCheckLists" [ngModel]="selectedTaskPlan" optionLabel="Code"
        (ngModelChange)="changeTaskPlan($event)" appendTo="body" [styleClass]="'fr__form-control'"
        (onClick)="loadTaskPlans(selectedBusinessUnit.Id)"
        [disabled]="selectedBusinessUnit === null && listCheckLists.length === 0"
        placeholder="{{ 'Select Option' | translate }}">
      </p-dropdown>
    </div>

    <div class="fr__moc-description col-sm-3">
      <b>
        <label>{{'FR.Titles.MOC' | translate}}:
          <span> {{ mocId }} </span>
        </label>

      </b>
    </div>
  </div>

  <div class="row" *ngIf="selectedBusinessUnit === null ||
  selectedAsset === null ||
  selectedTaskPlan === null">
    <div class="col-xs-12">
      <div class="alert alert-warning">
        {{'FR.Warnings.CannotStartFunctionalReview'|translate}}
      </div>
    </div>
  </div>


  <div class="row" *ngIf="activeFunctionalReview===null && mocId && selectedTaskPlan !== null">
    <div class="col-xs-12">
      <div class="alert alert-warning">
        {{'FR.Warnings.NotFoundFunctionalReview'|translate}}
      </div>
      <div class="text-right">
        <button type="button" class="btn btn-primary"
          (click)="startFunctionalReview()">{{'FR.Actions.Create'|translate}}</button>
      </div>
    </div>
  </div>



  <ng-container *ngIf="activeFunctionalReview !== null">

    <div class="row">
      <div class="col-xs-12">

        <ng-container *ngIf="sections$ | async as groupedResponses">
          <app-responses [groupedResponses]="groupedResponses"
            [functionalReviewId]="activeFunctionalReview.ID"></app-responses>
        </ng-container>


        <div class="responses__modification">
          <span class="alert alert-info">{{'FR.Titles.LastModification'|translate}}:
            {{activeFunctionalReview.UpdatedDate|date:'short'}}</span>
        </div>
      </div>
    </div>

    <ng-container *ngIf="status$ | async as functionalReviewStatus">

      <div class="row">
        <div class="col-md-12">
          <div *ngIf="functionalReviewStatus !== ResponseStatus.Answered" class="alert alert-warning" role="alert">
            {{'FR.Warnings.CannotComplete'|translate}}
          </div>
        </div>
      </div>

      <div class="row">
        <div class="fr__moc-actions--generate-report col-sm-offset-6 col-sm-3 col-xs-6 col-md-2 col-md-offset-8">
          <button [disabled]="functionalReviewStatus !== ResponseStatus.Answered" class="btn btn-secondary"
            type="button" (click)="generateReport()">{{'FR.Actions.GenerateReport' | translate}} </button>
        </div>
        <div class="fr__moc-actions--complete-review col-sm-3 col-xs-6 col-md-2">
          <button [disabled]="functionalReviewStatus !== ResponseStatus.Answered" class="btn btn-primary" type="button"
            (click)="completeFunctionalReview()">
            {{'FR.Actions.CompleteReview' | translate}}
          </button>
        </div>
      </div>
    </ng-container>
  </ng-container>


</div>